<!--
 * @Description: 富文本table回显
-->
<template>
  <a-tooltip placement="topLeft" v-if="valueComputed">
    <template #title>
      <p v-html="valueComputed"></p>
    </template>
    <p v-html="valueComputed" class="editorTxt"></p>
  </a-tooltip>
  <p v-else title="--">--</p>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import xss from 'xss'
const props = defineProps<{
  value: string | null
}>()
const valueComputed = computed(() => {
  return props.value ? xss(props.value) : ''
})
</script>
<script lang="ts">
export default { name: 'EditorTableText' }
</script>
<style scoped>
.editorTxt {
  max-height: 113px;
}
</style>
